export const SIDEBAR_MOBILE_LOGO = '/assets/logo/short/logo-77sol.svg'

export const SIDEBAR_DESKTOP_LOGO = '/assets/logo/main/logo-77sol.svg'

export const HOME_ACTIVE_ROUTES = ['/', '/dimensionar']
